import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class CostDocumentOtherItemViewModel {
  @IsString()
  @Expose()
  tmpId!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  serviceTypeId!: number | null;
  @IsNumber()
  @Expose()
  index!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  vat!: string;
  @IsNumber()
  @Expose()
  quantity!: number;
  @IsString()
  @Expose()
  unitType!: string;
  @IsNumber()
  @Expose()
  netPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsNumber()
  @Expose()
  vatAmountInCurrency!: number;
}
